(() => {
  'use strict';
  if (window.__ROCKY_RK5_CARDS__) return;
  window.__ROCKY_RK5_CARDS__ = true;

  const FAVORITES_KEY = 'rocky-favorites-v1';
  const $ = (selector, root = document) => root?.querySelector(selector) || null;
  const $$ = (selector, root = document) => (root ? [...root.querySelectorAll(selector)] : []);

  const readFavorites = () => {
    try {
      const value = JSON.parse(localStorage.getItem(FAVORITES_KEY) || '[]');
      return Array.isArray(value) ? [...new Set(value.filter(item => typeof item === 'string' && item))] : [];
    } catch {
      return [];
    }
  };

  const writeFavorites = favorites => {
    localStorage.setItem(FAVORITES_KEY, JSON.stringify([...new Set(favorites)]));
  };

  const showToast = message => {
    const toast = $('[data-rk4-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(Number(toast.dataset.rk5Timer || 0));
    const timer = window.setTimeout(() => toast.classList.remove('is-visible'), 2200);
    toast.dataset.rk5Timer = String(timer);
  };

  const syncFavorites = root => {
    const favorites = readFavorites();
    $$('[data-rk5-favorite]', root).forEach(button => {
      const active = favorites.includes(button.dataset.handle || '');
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? 'Favorilerden çıkar' : 'Favorilere ekle');
    });
  };

  const closePanel = (card, restoreFocus = false) => {
    const panel = $('[data-rk5-quick-panel]', card);
    if (!panel || panel.hidden) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    $$('[data-rk5-quick-open]', card).forEach(button => button.setAttribute('aria-expanded', 'false'));
    const trigger = card._rk5LastTrigger;
    window.setTimeout(() => {
      panel.hidden = true;
      if (restoreFocus && trigger instanceof HTMLElement) trigger.focus({ preventScroll: true });
    }, 230);
  };

  const closeAllPanels = except => {
    $$('[data-rk5-card]').forEach(card => {
      if (card !== except) closePanel(card, false);
    });
  };

  const openPanel = (card, trigger) => {
    const panel = $('[data-rk5-quick-panel]', card);
    if (!panel) return;
    closeAllPanels(card);
    card._rk5LastTrigger = trigger;
    panel.hidden = false;
    panel.setAttribute('aria-hidden', 'false');
    $$('[data-rk5-quick-open]', card).forEach(button => button.setAttribute('aria-expanded', 'true'));
    requestAnimationFrame(() => {
      panel.classList.add('is-open');
      $('[data-rk5-variant-select]', panel)?.focus({ preventScroll: true });
    });
  };

  const updateVariant = card => {
    const select = $('[data-rk5-variant-select]', card);
    const option = select?.selectedOptions?.[0];
    if (!option) return;

    const variantId = option.value;
    const available = option.dataset.available === 'true';
    const price = option.dataset.price || '';
    const compare = option.dataset.compare || '';
    const image = option.dataset.image || '';

    $$('[data-rk5-variant-input]', card).forEach(input => {
      input.value = variantId;
    });
    $$('[data-rk5-buy]', card).forEach(button => {
      button.dataset.variantId = variantId;
      button.disabled = !available;
    });
    $$('[data-rk5-add-button]', card).forEach(button => {
      button.disabled = !available;
      const label = $('span', button);
      if (label) label.textContent = available ? 'SEPETE EKLE' : 'TÜKENDİ';
    });
    $$('[data-rk5-current-price], [data-rk5-quick-price]', card).forEach(node => {
      node.textContent = price;
    });
    const compareNode = $('[data-rk5-compare-price]', card);
    if (compareNode) {
      compareNode.textContent = compare;
      compareNode.hidden = !compare;
    }
    if (image) {
      const primary = $('.rk5-card__image--primary', card);
      if (primary instanceof HTMLImageElement) {
        primary.removeAttribute('srcset');
        primary.src = image;
      }
      const addComponent = $('add-to-cart-component', card);
      addComponent?.setAttribute('data-product-variant-media', image);
    }
  };

  const cartAddEndpoint = () => {
    const base = String(window.RockyTheme?.cartAdd || '/cart/add').replace(/\/$/, '');
    return base.endsWith('.js') ? base : `${base}.js`;
  };

  const buyNow = async button => {
    const card = button.closest('[data-rk5-card]');
    const variantId = Number(button.dataset.variantId || $('[data-rk5-variant-input]', card)?.value || 0);
    if (!variantId || button.disabled) return;

    const previous = button.innerHTML;
    button.disabled = true;
    button.classList.add('is-loading');
    button.textContent = 'HAZIRLANIYOR…';

    try {
      const response = await fetch(cartAddEndpoint(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      if (!response.ok) throw new Error('cart-add-failed');
      const root = String(window.RockyTheme?.root || '/').replace(/\/$/, '');
      window.location.assign(`${root}/checkout`.replace(/^\/\//, '/'));
    } catch {
      button.disabled = false;
      button.classList.remove('is-loading');
      button.innerHTML = previous;
      showToast('İŞLEM TAMAMLANAMADI. LÜTFEN TEKRAR DENE.');
    }
  };

  document.addEventListener('click', event => {
    const favorite = event.target.closest('[data-rk5-favorite]');
    if (favorite) {
      event.preventDefault();
      event.stopPropagation();
      const handle = favorite.dataset.handle || '';
      if (!handle) return;
      const favorites = readFavorites();
      const active = favorites.includes(handle);
      writeFavorites(active ? favorites.filter(item => item !== handle) : [...favorites, handle]);
      syncFavorites(document);
      showToast(active ? 'FAVORİLERDEN ÇIKARILDI' : 'FAVORİLERE EKLENDİ');
      return;
    }

    const opener = event.target.closest('[data-rk5-quick-open]');
    if (opener) {
      event.preventDefault();
      const card = opener.closest('[data-rk5-card]');
      if (card) openPanel(card, opener);
      return;
    }

    const closer = event.target.closest('[data-rk5-quick-close]');
    if (closer) {
      event.preventDefault();
      const card = closer.closest('[data-rk5-card]');
      if (card) closePanel(card, true);
      return;
    }

    const buy = event.target.closest('[data-rk5-buy]');
    if (buy) {
      event.preventDefault();
      buyNow(buy);
      return;
    }

    if (!event.target.closest('[data-rk5-quick-panel]')) closeAllPanels(null);
  });

  document.addEventListener('change', event => {
    const select = event.target.closest('[data-rk5-variant-select]');
    if (!select) return;
    const card = select.closest('[data-rk5-card]');
    if (card) updateVariant(card);
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const openPanelNode = $('[data-rk5-quick-panel].is-open');
    const card = openPanelNode?.closest('[data-rk5-card]');
    if (card) closePanel(card, true);
  });

  document.addEventListener('cart:add', event => {
    const source = event.target?.closest?.('[data-rk5-card]');
    if (source) closePanel(source, false);
  });

  document.addEventListener('shopify:section:load', event => {
    syncFavorites(event.target);
    $$('[data-rk5-card]', event.target).forEach(updateVariant);
  });

  document.addEventListener('rocky:products-loaded', event => {
    syncFavorites(event.detail.root);
    $('[data-rk5-card]', event.detail.root).forEach(updateVariant);
  });

  const init = () => {
    syncFavorites(document);
    $$('[data-rk5-card]').forEach(updateVariant);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
